import * as React from "react";

function SvgCheckFilled16Px(props) {
  return <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Zm3.766-9.357a1 1 0 0 0-1.532-1.286l-3.477 4.14-1.03-1.092a1 1 0 0 0-1.455 1.372l1.164 1.234.454.482.134.142.036.038.01.01.002.002v.001L6.8 11l-.728.686a1 1 0 0 0 1.494-.043l4.2-5Z" fill="currentColor" /></svg>;
}

export default SvgCheckFilled16Px;